import { Box, Breadcrumb, Breadcrumbs, Divider } from "@carrotfertility/carotene-core"
import React from "react"
import { Link } from "react-router-dom"

export function BookingBreadcrumbs({ onReturnToSearchResults }: { onReturnToSearchResults?: () => void }) {
  const firstBreadcrumb = onReturnToSearchResults ? (
    <Breadcrumb component="button" type="button" onClick={onReturnToSearchResults}>
      Search results
    </Breadcrumb>
  ) : (
    <Breadcrumb component={Link} to="/">
      Your Carrot Plan
    </Breadcrumb>
  )
  return (
    <Box sx={(theme) => ({ display: "flex", flexDirection: "column", gap: theme.spacing(theme.tokens.spacing.sm) })}>
      <Breadcrumbs>
        {firstBreadcrumb}
        <Breadcrumb currentPage>Book now</Breadcrumb>
      </Breadcrumbs>
      <Divider />
    </Box>
  )
}
